import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.webp";
import { MdCall } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import { FaLinkedinIn, FaXTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { FaArrowUp, FaTwitter } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa6";
import dmca from "../../assets/images/dmca.webp";
import { GrInstagram } from "react-icons/gr";
import { RiFacebookFill } from "react-icons/ri";
import { routes } from "../../config/utilities/utils.constant";
import { Link } from "react-router-dom";
import DMCABadge from "../DMCABadge";
import { IoLogoGithub } from "react-icons/io";
import { SiMedium } from "react-icons/si";
import { MdChevronRight } from "react-icons/md";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  const services = [
    {
      service: "Mobile App Development",
      Link: routes.MOBILEAPPLICATIONDEVELOPMENT,
      children: [
        {
          service: "Cross-Platform Mobile App Development",
          link: routes.CROSSPLATFORMMOBILEAPPDEVELOPMENT,
        },
        {
          service: "Native Mobile App Development",
          link: routes.NATIVEAPPDEVELOPMENT,
        },
      ],
    },

    { service: "IoT  Development", Link: routes.IOTDEVELOPMENTSERVICE },
    {
      service: "Web Application Development ",
      Link: routes.WEBAPPS,
    },
    {
      service: "Graphic and UI/UX Designing",
      Link: routes.GRAPHICANDUIUXDESIGNING,
    },
    { service: "CMS Development", Link: routes.CMSDEVELOPMENT },
    {
      service: "Digital Marketing",
      Link: routes.DIGITALMARKETING,
      children: [
        {
          service: "Search Engine Optimization",
          link: routes.SEARCHENGINEOPTIMIZATION,
        },
      ],
    },
    {
      service: "AI Integrations and Chatbots",
      Link: routes.AIINTEGRATIONSANDCHATBOTS,
    },
  ];

  const quickLinks = [
    { label: "Home", Link: routes.HOME },
    { label: "About Us", Link: routes.ABOUTUS },
    { label: "Contact Us", Link: routes.CONTACTUS },
    { label: "Blogs", Link: routes.BLOGS },
    { label: "FAQs", Link: routes.FAQ },
  ];
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <footer className="bg-gradient-to-br from-[#6D1349] to-[#DF73FF] py-20  px-6 min-[550px]:px0 lg:px-0 ">
      <div className="container ">
        <div className="gap grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-y-12 lg:gap-y-0  gap-8">
          <div className="space-y-8 md:sp ace-y-8 xl:col-span-2 flex flex-col  ">
            <div className="">
              <Link
                to={routes.HOME}
                aria-label="Internal link to Apptalyst homepage"
              >
                <img
                  src={logo}
                  alt="Apptalyst official company logo"
                  height={320}
                  width={320}
                  className="w-80 mx-auto sm:mx-0"
                />
              </Link>
            </div>
            <div className="space-y-8 text-base ">
              <div className="space-y-2">
                <div className="border-b border-gray-300 pb-[1px]">
                  <p className="font-semibold text-white"> Headquarters</p>
                </div>

                <p className="font-semibold text-base text-white">
                  11819 Thomas Ave, Great Falls, VA, 22066, USA.
                </p>
              </div>
              <div className="space-y-2">
                <div className="border-b border-gray-300 pb-[1px]">
                  <p className="font-semibold text-white"> Other Locations</p>
                </div>

                <p className="font-semibold text-base  text-white">
                  Karachi, Pakistan.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8 md:space-y-8 xl:col-span-2">
            <span className="text-3xl font-semibold text-white  ">
              Services
            </span>
            <ul className="space-y-3 text-base font-semibold text-white">
              {services.map((item, index) => (
                <li
                  key={index}
                  className="cursor-pointer transition-colors duration-300 ease-in text-white "
                >
                  {item.Link ? (
                    <Link
                      to={item.Link}
                      className={` ${
                        location.pathname === item.Link
                          ? "text-[#FFC067]"
                          : "text-[#fff]"
                      }  hover:text-[#FFC067] transition-colors duration-300 ease-in`}
                    >
                      {item.service}
                    </Link>
                  ) : (
                    <span className="hover:text-[#FFC067] transition-colors duration-300 ease-in">
                      {item.service}
                    </span>
                  )}
                  {item.children && (
                    <ul className="space-y-2 mt-1">
                      {item.children.map((ele, index) => (
                        <li
                          key={index}
                          className={`cursor-pointer transition-colors duration-300 ease-in group ${
                            location.pathname === ele.link
                              ? "text-[#FFC067]"
                              : "text-[#fff]"
                          } flex pl-1`}
                        >
                          <MdChevronRight
                            className={`text-base mt-0.5 min-w-max  transition-colors duration-300 ease-in${
                              location.pathname === ele.link
                                ? "text-[#FFC067]"
                                : "text-[#fff]"
                            }  group-hover:text-[#FFC067]`}
                          />
                          {ele.link ? (
                            <Link
                              className="group-hover:text-[#FFC067] transition-colors duration-300 ease-in"
                              to={ele.link}
                            >
                              {ele.service}
                            </Link>
                          ) : (
                            <span className="group-hover:text-[#FFC067] transition-colors duration-300 ease-in">
                              {ele.service}
                            </span>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}{" "}
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-8 md:space-y-8 xl:col-span-1 flex-shrink xl:-ml-10">
            <span className="text-3xl font-semibold text-white ">
              Quick Links
            </span>
            <ul className="space-y-2 text-base font-semibold text-white">
              {quickLinks.map(({ label, Link: path }, index) => (
                <li
                  key={index}
                  className={`cursor-pointer transition-colors duration-300 ease-in  ${
                    location.pathname === path
                      ? "text-[#FFC067]"
                      : "text-[#fff]"
                  }   hover:text-[#FFC067]`}
                >
                  {path ? <Link to={path}>{label}</Link> : <span>{label}</span>}
                </li>
              ))}
            </ul>
          </div>
          <div className="  flex xl:justify-end  ">
            <div className="space-y-4 w-max   ">
              <div className="group text-base flex items-center font-semibold text-white space-x-2 xl:mt-16 ">
                <span>
                  <MdCall className="text-2xl transition-colors duration-300 ease-in group-hover:text-[#FFC067]" />{" "}
                </span>{" "}
                <a
                  href="tel:+17033812998"
                  className="transition-colors duration-300 ease-in group-hover:text-[#FFC067]"
                >
                  (703) 381-2998
                </a>
              </div>
              <div className="group text-base flex items-center font-semibold text-white space-x-2   ">
                <span>
                  <MdEmail className="text-2xl  transition-colors duration-300 ease-in group-hover:text-[#FFC067]" />{" "}
                </span>{" "}
                <span className=" transition-colors duration-300 ease-in group-hover:text-[#FFC067]">
                  {" "}
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=info@apptalyst.com&su=Subject&body=Message"
                    target="_blank"
                  >
                    info@apptalyst.com
                  </a>
                </span>
              </div>

              <div className="pt-3 ">
                <div className="flex items-center gap-3">
                  {/* LinkedIn */}
                  <a
                    href="https://www.linkedin.com/company/apptalyst-llc/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Apptalyst LinkedIn page"
                  >
                    <div className="px-2.5 py-2.5 bg-white  hover:bg-[#FFC067] flex items-center justify-center rounded-md transition-colors duration-300 ease-in group">
                      <FaLinkedinIn className="text-[#6D1349] text-lg transition-colors duration-300 group-hover:text-[#6D1349]" />
                    </div>
                  </a>
                  {/* github */}
                  <a
                    href="https://github.com/Apptalyst"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Apptalyst Github page"
                  >
                    <div className="px-2.5 py-2.5 bg-white  hover:bg-[#FFC067] flex items-center justify-center rounded-md transition-colors duration-300 ease-in group cursor-pointer">
                      <IoLogoGithub className="text-[#6D1349] text-lg transition-colors duration-300 group-hover:text-[#6D1349]" />
                    </div>
                  </a>
                  {/* medium */}
                  <a
                    href="https://medium.com/@apptalyst"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Apptalyst Medium page"
                  >
                    <div className="px-2.5 py-2.5 bg-white  hover:bg-[#FFC067] flex items-center justify-center rounded-md transition-colors duration-300 ease-in group cursor-pointer">
                      <SiMedium className="text-[#6D1349] text-lg transition-colors duration-300 group-hover:text-[#6D1349]" />
                    </div>
                  </a>
                  {/* Pinterest */}
                  <a
                    href="https://www.pinterest.com/Apptalyst/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Visit Apptalyst Pinterest page"
                  >
                    <div className="px-2.5 py-2.5 bg-white  hover:bg-[#FFC067] flex items-center justify-center rounded-md transition-colors duration-300 ease-in group">
                      <FaPinterest className="text-[#6D1349] text-lg transition-colors duration-300 group-hover:text-[#6D1349]" />
                    </div>
                  </a>
                </div>
              </div>
              <div className="pt-5">
                {/* <img src={dmca} alt="" loading="lazy" className="w-20" width={20} height={20} /> */}
                <DMCABadge />
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-300 mt-8 pt-6 text-center text-lg text-white">
          <div className="flex flex-col space-y-4  md:space-y-0 lg:flex-row justify-between ">
            <div className="flex flex-col lg:flex-row text-base">
              <p>© Copyright 2026 Apptalyst LLC.&nbsp;</p>
              <p>All Rights Reserved.</p>
            </div>

            <p>
              {" "}
              <Link
                to={routes.TERMSANDCONDITIONS}
                className={`${
                  location.pathname === routes.TERMSANDCONDITIONS
                    ? "text-[#FFC067]"
                    : "text-[#fff]"
                }  transition-colors duration-300 ease-in   hover:text-[#FFC067] text-base`}
              >
                {" "}
                Terms of Service{" "}
              </Link>
              |{" "}
              <Link
                to={routes.PRIVACYPOLICY}
                className={`transition-colors duration-300 ease-in ${
                  location.pathname === routes.PRIVACYPOLICY
                    ? "text-[#FFC067]"
                    : "text-[#fff]"
                }   hover:text-[#FFC067] text-base`}
              >
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}

      <div
        className={`fixed bottom-24  right-9 z-40 bg-[#6D1349] rounded-full p-[1px]  transition-all duration-500 ease-in-out  ${
          isVisible ? "opacity-100 " : "opacity-0  pointer-events-none"
        } `}
      >
        <button
          onClick={scrollToTop}
          className="p-3 bg-[#f3ebfa] text-[#6D1349] rounded-full shadow-lg hover:bg[#DF73FF] hover:textwhite transition-colors duration-300"
          aria-label="Scroll to top"
        >
          <FaArrowUp />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
